import { Component, Input, ViewChild, ElementRef, OnChanges, SimpleChanges, OnInit } from '@angular/core';

/**
 * Generated class for the CircleProgressComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'circle-progress',
  template: `
  <div [ngStyle]="{'width': size + 'px', 'height': size + 'px',
    'position' : 'absolute', 'display': 'flex', 'flex-direction': 'column', 'justify-content': 'center', 'align-items': 'center'}">
      <div style="flex-direction: column" [ngStyle]="{'font-size': fontSize, 'color': fontColor==''? mainColor : fontColor}">{{ content }}<br></div>
      <div style="flex-direction: column" [ngStyle]="{'font-size': subFontSize, 'color': fontColor==''? mainColor : fontColor}">{{ subContent }}</div>
  </div>
  <svg [attr.height]="size" [attr.width]="size">

      <defs>
          <marker [attr.id]="markerId" markerWidth="6" markerHeight="6" refX="5" refY="5">
              <circle cx="5" cy="5" r="0.7" style="stroke: none;" [style.fill]="mainColor" />
          </marker>
      </defs>


      <!--
      <circle [attr.cx]="size/2" [attr.cy]="size/2" [attr.r]="radius" [attr.stroke]="subColor"
      [attr.stroke-width]="lineWidth" fill="transparent" />
      -->

      <path fill="none" [attr.stroke]="subColor"
        [attr.stroke-width]="lineWidth"
        [attr.d]="progressBarBgPath"
        [attr.stroke-dasharray]="circumference"
        attr.stroke-dashoffset="0"
        >
      </path>

      <path fill="none" [attr.stroke]="mainColor"
        [attr.stroke-width]="lineWidth"
        [attr.d]="progressBarPath"
        [attr.stroke-dasharray]="dashArray"
        [attr.stroke-dashoffset]="0"
        [attr.marker-end]="'url(#' + markerId + ')'"
        >

        <!--
        <animate
          attributeName="stroke-dashoffset"
          [attr.from]="dashOffset"
          to="0"
          dur="1s"
          fill="freeze"
          #animation1
        />

        <animate
          attributeName="stroke-dashoffset"
          [attr.to]="dashOffset"
          from="0"
          dur="0.1s"
          fill="freeze"
          begin="indefinite"
          #animation1r
        />
        -->
      </path>

      <!--
      <circle cx="0" cy="0" r="3" [attr.fill]="mainColor">
        <animateMotion dur="1s" fill="freeze"  calcMode="linear" #animation2>
          <mpath [attr.xlink:href]="'#' + markerId" />
        </animateMotion>
        <animateMotion dur="0.1s" fill="freeze" keyPoints="1;0" keyTimes="0;1" calcMode="linear" begin="indefinite" #animation2r>
          <mpath [attr.xlink:href]="'#' + markerId" />
        </animateMotion>
      </circle>
      -->

  </svg>
  `,
  styles:[`
    :host {
      display: inline-block
    }`,
    `span {
      display: inline-block; text-align: center; position: absolute; font-weight: bold
    }`
  ]
})

export class CircleProgressComponent implements OnInit, OnChanges{

  @Input() size?: number = 100;
  @Input() percentage?: number = 0;
  @Input() lineWidth?: number = 3;
  @Input() mainColor?: string = "#555555";
  @Input() subColor?: string = "#E9E9E9";
  @Input() endPointRatio?: number = 1;
  @Input() fontSize?: string = "20px";
  @Input() subFontSize?: string = "15px";
  @Input() fontColor?: string = "";
  @Input() content?: string = this.percentage + '';
  @Input() subContent?: string = '';
  @Input() id?: string = new Date().getTime() + '';
  @ViewChild('animation1') animation1: ElementRef;
  @ViewChild('animation1r') animation1r: ElementRef;
  @ViewChild('animation2') animation2: ElementRef;
  @ViewChild('animation2r') animation2r: ElementRef;

  radius: number;
  circumference: number;
  dashOffset: number;
  dashArray: number;
  endPointRadius: number;
  progressBarPath: string;
  progressBarBgPath: string;
  markerId: string;



  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.drawCirle();
  }

  runAnimation() {
    // if (this.animation1.nativeElement != null) {
    //   this.animation1.nativeElement.beginElement();
    // }
    // if (this.animation2.nativeElement != null) {
    //   this.animation2.nativeElement.beginElement();
    // }
  }

  clearAnimation() {
    // if (this.animation1r.nativeElement != null) {
    //   this.animation1r.nativeElement.beginElement();
    // }
    // if (this.animation2r.nativeElement != null) {
    //   this.animation2r.nativeElement.beginElement();
    // }
  }

  ngOnInit() {
    this.drawCirle();
  }

  drawCirle() {

    this.endPointRadius = this.lineWidth * this.endPointRatio;
    this.radius = this.size/2 - this.lineWidth - this.endPointRadius;
    this.circumference = 2 * Math.PI * this.radius;
    this.dashOffset = this.circumference * this.percentage / 100;
    this.dashArray = this.circumference * this.percentage / 100;

    /*
    let angle = this.getAngleInRadian(0);
    this.endPointX = this.size/2 + this.radius * Math.cos(angle);
    this.endPointY = this.size/2 + this.radius * Math.sin(angle);
    this.endPointPath = this.describeArc(this.size/2, this.size/2, this.radius, 0, this.percentage * 3.6);
    this.endPointTransformOrigin = this.size/2 + "px " + this.size/2 + "px";
    */

    this.progressBarPath = this.describeArc(this.size/2, this.size/2, this.radius, 0, this.percentage * 3.6);
    this.progressBarBgPath = this.describeArc(this.size/2, this.size/2, this.radius, 0, 99.99 * 3.6);
    this.markerId = "markerCircle" + new Date().getTime() + "_" + this.id;

  }

  getEndPointPath(radius: number, percentage: number):string {
    let angle = this.getAngleInRadian(percentage);
    let x = this.size/2 + radius * Math.cos(angle);
    let y = this.size/2 + radius * Math.sin(angle)
    return "M " + x + ", " + y + " Z";
  }


  getAngleInRadian(percentage) {
    return percentage * 3.6 * Math.PI / 180;
  }

  polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;

    return {
      x: centerX + (radius * Math.cos(angleInRadians)),
      y: centerY + (radius * Math.sin(angleInRadians))
    };
  }

  describeArc(x, y, radius, startAngle, endAngle){
    if (endAngle == 360) {
      endAngle = 359.99;
    }

    let start = this.polarToCartesian(x, y, radius, startAngle);
    let end = this.polarToCartesian(x, y, radius, endAngle);

    let largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    var d = [
        "M", start.x, start.y,
        "A", radius, radius, 0, largeArcFlag, 1, end.x, end.y
    ].join(" ");

    return d;
  }

}



// WEBPACK FOOTER //
// ./src/components/circle-progress/circle-progress.ts